import styled from 'styled-components';
import { media } from '../../../Utils/mediaQueries';

export const CardContainer = styled.div`
    height: 270px;
    background-image: ${props => {
        if (props.bg) return props.bg;
        return 'radial-gradient(circle at 48% 3%, #fb721b, #fd3260)';
    }};

    margin: 8px;
    border-radius: 10px;
    // min-width: 360px;
    width: 375px;
    min-height: 225px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ${media.phone`
        width: 320px;
    `};

    @media (min-width: 1025px) and (max-width: 1117px) {
        width: 350px;
        margin: 4px;
    }
`;

export const Header = styled.div`
    height: 42px;
`;

export const IconWrapper = styled.div`
    position: relative;
`;

export const Circles = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const HeaderIcon = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 36px;
    height: 36px;
    margin: auto;
`;

export const SeparatorLine = styled.div`
    width: 100%;
    height: 6px;
    border-radius: 4px;
    opacity: 0.2;
    background-color: #ffffff;
    width: 50%;
    margin: 0 auto;
`;

export const ItemBox = styled.div`
    margin: 4px 0;
`;

export const CircleIconWrap = styled.div`
    position: relative;
    top: 10px;
    width: 51px;
    height: 59px;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/LeaderboardCard/style.js